// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 158) return "static/chunks/775fa796-104d853e40ffa044.js";
	if (chunkId === 625) return "static/chunks/625-536f61a80a1dfe5d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"e38667558666d435","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"9dde84f0559dd22a","367":"7dcbc6e6a616c554","639":"775d77a54aff863d","748":"5cb64af94cdf273d"}[chunkId] + ".js";
};